import * as i0 from '@angular/core';
import { Pipe } from '@angular/core';

/**
 * For any new
 */
const iconSizeMap = {
    xs: 'md-14',
    sm: 'md-18',
    md: 'md-24',
    lg: 'md-36',
    xl: 'md-48',
};
function transformIconSizeToSize(iconSize) {
    if (Object.values(iconSizeMap).includes(iconSize)) {
        const size = Object.entries(iconSizeMap).find(([key, value]) => value === iconSize);
        return size ? size[0] : 'md';
    }
    return iconSize;
}
function transformToIconSize(size) {
    if (size in iconSizeMap) {
        return iconSizeMap[size];
    }
    return size;
}
class SizeToIconSizePipe {
    transform(size) {
        return transformToIconSize(size);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: SizeToIconSizePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: SizeToIconSizePipe, isStandalone: true, name: "sizeToIconSize" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: SizeToIconSizePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'sizeToIconSize',
                    standalone: true,
                }]
        }] });

const sizes = ['xs', 'sm', 'md', 'lg', 'xl'];
// ! IconSize lives in icons.ts

const DEFAULT_THEME = 'default';
/**
 *
 *
 * @export
 * @class Util
 */
class Util {
    /**
     *
     *
     * @static
     * @param {string} [nodeName='app-root']
     * @returns {*}
     * @memberof Util
     */
    static getElement(nodeName = 'app-root') {
        return document.querySelector(nodeName);
    }
    /**
     *
     *
     * @static
     * @returns
     * @memberof Util
     */
    static getTheme() {
        let elementNode = Util.getElement();
        const { className } = elementNode;
        if (className && className.split('-').length > 1) {
            return className.split('-')[1];
        }
        return DEFAULT_THEME;
    }
}

const ACCEPT_FILE_TYPES = [
    '*',
    'image/*',
    '.jpeg',
    '.jpg',
    '.png',
    '.gif',
    '.svg',
    '.bmp',
    '.webp',
    '.ico',
    '.psd',
    'audio/*',
    '.mp3',
    '.wav',
    '.ogg',
    '.midi',
    '.flac',
    '.aac',
    '.wma',
    '.aiff',
    '.alac',
    '.pcm',
    '.dsd',
    'video/*',
    '.mp4',
    '.webm',
    '.ogg',
    '.avi',
    '.mov',
    '.flv',
    '.wmv',
    '.mkv',
    '.ts',
    '.m4v',
    '.m4p',
    '.m4a',
    '.m4b',
    '.m4r',
    '.mpg',
    '.mpeg',
    '.mpe',
    '.mpv',
    '.mp2',
    '.mp2v',
    '.m2v',
    '.m2ts',
    '.mts',
    '.tts',
    'text/*',
    '.pdf',
    '.xls',
    '.xlsx',
    '.doc',
    '.docx',
    '.ppt',
    '.pptx',
    'application/*',
    '.json',
    '.xml',
    '.zip',
    '.tar',
    '.gz',
    '.bz',
    '.7z',
    '.txt',
    '.csv',
];

/**
 * Generated bundle index. Do not edit.
 */

export { ACCEPT_FILE_TYPES, SizeToIconSizePipe, Util, iconSizeMap, sizes, transformIconSizeToSize };
